module.exports = __webpack_public_path__ + "img/pitch_t.745e029c.svg";